import React from 'react';
import PropTypes from 'prop-types';
import { YEARS_OF_EXPERIENCE_VALUES } from '../../../../utils/constants';

const calcLevel = (yearsOfExperience) => {
  return (
    Object.values(YEARS_OF_EXPERIENCE_VALUES).indexOf(yearsOfExperience) + 1
  );
};

const SkillBarSegment = ({ active }) => {
  return <div className={`skillbar__segment${active ? ' active' : ''}`} />;
};

const SkillBarDefault = (maxLevel, level) => {
  const segments = [];
  for (let i = 0; i < maxLevel; i++) {
    segments.push(<SkillBarSegment key={i} active={i < level} />);
  }
  return <section className="skillbar__container">{segments}</section>;
};

const AltStyleSegment = ({ active }) => {
  return <div className={`skillbaralt__segment${active ? ' active' : ''}`} />;
};

const SkillBarAlt = (maxLevel, level) => {
  const segmentsTop = [];
  const segmentsBottom = [];

  for (let i = 0; i < maxLevel; i++) {
    if (i % 2 === 0) {
      segmentsTop.push(<AltStyleSegment key={i} active={i < level} />);
    } else {
      segmentsBottom.push(<AltStyleSegment key={i} active={i < level} />);
    }
  }
  return (
    <div style={{ marginRight: '8px' }}>
      <section className="skillbaralt__container">{segmentsTop}</section>
      <section className="skillbaralt__container">{segmentsBottom}</section>
    </div>
  );
};

const SkillBar = ({ yearsOfExperience, altStyle }) => {
  const maxLevel = Object.keys(YEARS_OF_EXPERIENCE_VALUES).length;
  const level = calcLevel(yearsOfExperience);

  return altStyle ? SkillBarAlt(maxLevel, level) : SkillBarDefault(maxLevel, level);
};

SkillBar.propTypes = {
  yearsOfExperience: PropTypes.string.isRequired
};

export default SkillBar;
